export default function ExternalTrainerSection() {
  const advantages = [
    {
      icon: 'ri-eye-line',
      title: 'Независимый взгляд',
      desc: 'Внешний эксперт видит то, что невозможно заметить изнутри. Он не вовлечён во внутреннюю политику компании и может честно указать на проблемы.'
    },
    {
      icon: 'ri-global-line',
      title: 'Кросс-отраслевая экспертиза',
      desc: 'Бизнес-тренер работает с десятками компаний из разных отраслей. Он приносит лучшие практики рынка, которые уже доказали свою эффективность.'
    },
    {
      icon: 'ri-focus-2-line',
      title: 'Фокус на результате',
      desc: 'Внешний провайдер заинтересован в измеримом результате — его репутация и будущие проекты зависят от эффективности обучения.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Эффект приглашённого эксперта',
      desc: 'Сотрудники воспринимают внешнего тренера как авторитет. Эффект новизны и статус эксперта повышают вовлечённость и усвоение материала.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Методология и инструменты',
      desc: 'Профессиональный тренер владеет десятками методик и инструментов, адаптирует их под специфику бизнеса и уровень участников.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Объективная оценка',
      desc: 'Внешний эксперт проводит честный аудит компетенций и даёт непредвзятую обратную связь — без оглядки на внутреннюю иерархию.'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Быстрый запуск',
      desc: 'Не нужно нанимать и обучать внутреннего тренера. Внешний эксперт готов начать работу сразу после диагностики.'
    },
    {
      icon: 'ri-repeat-line',
      title: 'Долгосрочное партнёрство',
      desc: 'Внешний провайдер заинтересован в долгосрочном сотрудничестве. Он сопровождает внедрение изменений и корректирует программу по мере развития бизнеса.'
    },
  ];

  return (
    <section id="trainer" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-4">
          Почему компании выбирают внешнего тренера
        </h2>
        <p className="text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto">
          Восемь причин, почему приглашённый эксперт даёт результат, которого сложно достичь силами внутренних специалистов
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {advantages.map((adv, i) => (
            <div key={i} className="bg-white p-6 rounded-xl hover:shadow-md transition-shadow group">
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${adv.icon} text-lg text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{adv.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{adv.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mt-12 text-center">
          <div className="bg-teal-50 border border-teal-200 rounded-xl px-6 py-5">
            <p className="text-base md:text-lg font-semibold text-teal-800 leading-relaxed">
              Именно внешняя экспертиза позволяет увидеть слепые зоны, привнести лучшие практики и достичь измеримых бизнес-результатов. BusinessTraining.by — это 18+ лет опыта внешнего корпоративного обучения для бизнеса.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}